import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var _hoisted_2 = ["stroke"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'ArrowToRightIcon',
    props: {
        color: {
            type: String,
            required: true
        }
    },
    setup: function (__props) {
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
                _createElementVNode("path", {
                    d: "M10 8L14 12L10 16",
                    stroke: __props.color,
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                }, null, 8, _hoisted_2)
            ]));
        };
    }
});
